var map = {
	"./001.jpeg": 1794,
	"./002.jpeg": 9957,
	"./003.jpeg": 1803,
	"./004.jpeg": 9843,
	"./005.jpeg": 6097,
	"./006.jpeg": 6330,
	"./007.jpeg": 9871,
	"./008.jpeg": 7852,
	"./009.jpeg": 2615,
	"./010.jpeg": 5871,
	"./011.jpeg": 3348,
	"./012.jpeg": 1903,
	"./013.jpeg": 2269,
	"./014.jpeg": 4534,
	"./015.jpeg": 5116,
	"./016.jpeg": 1425,
	"./017.jpeg": 535,
	"./018.jpeg": 2027,
	"./019.jpeg": 9769,
	"./14 (1).JPG": 6801,
	"./21 (1).jpeg": 8714,
	"./3 The Virtue of Wellness.jpg": 4370,
	"./36 (1).JPG": 4620,
	"./38 (1).JPG": 7127,
	"./8 Spreading Awareness (1).jpg": 9322,
	"./9 Disciples of Discipline (1).JPG": 9098,
	"./Art Gallery (1).JPG": 2637,
	"./Auditorium pic.jpg": 2272,
	"./Banking.jpeg": 4214,
	"./Basket Ball (1).JPG": 9085,
	"./Bio lab .jpeg": 5411,
	"./BioLab (3) (1) (1) (1).JPG": 9253,
	"./Chem Lab (1).JPG": 5308,
	"./Chemistry lab .jpeg": 8040,
	"./Coding-1.jpeg": 4040,
	"./Coding-2.jpeg": 2886,
	"./Coding-3.jpeg": 9393,
	"./Computer-1.jpeg": 26,
	"./Computer-2.jpeg": 855,
	"./DSC09508.jpg": 7415,
	"./Dance room.jpeg": 9497,
	"./FIRST Aid.jfif": 4309,
	"./Home science lab.jpg": 4219,
	"./IMG-20160220-WA0000.jpg": 3993,
	"./IMG-20160220-WA0001.jpg": 3663,
	"./IMG-20210218-WA0013.jpg": 729,
	"./IMG-20210601-WA0087.jpg": 2761,
	"./IMG-20211011-WA0019.jpg": 7082,
	"./IMG-20220130-WA0025.jpg": 419,
	"./IMG-20220208-WA0017.jpg": 5745,
	"./IMG-20220208-WA0019.jpg": 8768,
	"./IMG-20220208-WA0020.jpg": 9709,
	"./IMG-20220208-WA0021.jpg": 9493,
	"./IMG-20220208-WA0022.jpg": 241,
	"./IMG-20220208-WA0023.jpg": 5337,
	"./IMG-20220208-WA0024.jpg": 6858,
	"./IMG-20220208-WA0025.jpg": 6082,
	"./IMG-20220208-WA0026.jpg": 4217,
	"./IMG-20220208-WA0027.jpg": 1606,
	"./IMG-20220208-WA0029.jpg": 9179,
	"./IMG-20220208-WA0031.jpg": 3466,
	"./IMG-20220208-WA0032.jpg": 6183,
	"./IMG-20220208-WA0033.jpg": 6204,
	"./IMG-20220208-WA0035.jpg": 9041,
	"./IMG-20220523-WA0023 (2).jpg": 7135,
	"./Learning Outcome-1 (1).jpeg": 8244,
	"./Learning Outcome-1 (2).jpeg": 2146,
	"./Learning Outcome-1 (3).jpeg": 2591,
	"./Learning Outcome-1 (4).jpeg": 3602,
	"./Learning Outcome-1 (6).jpeg": 5915,
	"./Library (2) (1) (1).JPG": 1738,
	"./Living Science lab (1).jpeg": 2783,
	"./Living Science lab (2).jpeg": 6590,
	"./Making of Kutub Minar.jfif": 7215,
	"./Mass Media (2).jfif": 7404,
	"./Mass Media- Field Trip.jfif": 8376,
	"./Music Room (1).JPG": 1438,
	"./NCC (2) (1) (1).JPG": 3076,
	"./NEP-1 (10).jpeg": 1672,
	"./NEP-1 (11).jpeg": 4004,
	"./NEP-1 (17).jpeg": 9125,
	"./NEP-1 (4).jpeg": 9482,
	"./NEP-1 (5).jpeg": 234,
	"./NEP-1 (9).jpeg": 683,
	"./Physics lab.jpeg": 983,
	"./Primary Class Room (2) (1).JPG": 8643,
	"./Protection Against Covid (1) (1).JPG": 2551,
	"./STEM 2.jfif": 3036,
	"./Stem-1.jpeg": 8441,
	"./TT (1).JPG": 2111,
	"./Toppers.jfif": 1721,
	"./VTC-1 (1).jpeg": 6289,
	"./VTC-1 (2).jpeg": 243,
	"./WhatsApp Image 2022-02-09 at 1.10.26 PM (5).jpeg": 4952,
	"./WhatsApp Image 2022-02-09 at 1.10.58 PM (10).jpeg": 5316,
	"./WhatsApp Image 2022-02-09 at 1.10.58 PM (12).jpeg": 5808,
	"./WhatsApp Image 2022-02-09 at 1.10.58 PM (16).jpeg": 8513,
	"./WhatsApp Image 2022-02-09 at 1.10.58 PM (4).jpeg": 8626,
	"./WhatsApp Image 2022-02-09 at 1.10.58 PM (5).jpeg": 9045,
	"./WhatsApp Image 2022-02-09 at 1.10.58 PM (6).jpeg": 2441,
	"./WhatsApp Image 2022-02-09 at 1.10.58 PM (8).jpeg": 5110,
	"./WhatsApp Image 2022-02-09 at 1.10.58 PM (9).jpeg": 2105,
	"./WhatsApp Image 2022-02-09 at 1.55.53 PM.jpeg": 3299,
	"./WhatsApp Image 2022-02-09 at 1.56.57 PM (1).jpeg": 5869,
	"./WhatsApp Image 2022-02-09 at 1.56.58 PM (1).jpeg": 3329,
	"./WhatsApp Image 2022-02-09 at 1.56.58 PM.jpeg": 3863,
	"./WhatsApp Image 2022-02-09 at 10.44.45 AM.jpeg": 3628,
	"./WhatsApp Image 2022-02-09 at 10.44.46 AM.jpeg": 4789,
	"./WhatsApp Image 2022-02-09 at 10.44.52 AM.jpeg": 6918,
	"./WhatsApp Image 2022-02-09 at 2.55.06 PM.jpeg": 7765,
	"./WhatsApp Image 2022-02-09 at 2.57.59 PM.jpeg": 7677,
	"./WhatsApp Image 2022-02-09 at 2.59.34 PM.jpeg": 7716,
	"./WhatsApp Image 2022-02-09 at 3.02.06 PM.jpeg": 3679,
	"./WhatsApp Image 2022-02-09 at 3.04.57 PM (1).jpeg": 8796,
	"./WhatsApp Image 2022-02-09 at 3.05.29 PM.jpeg": 5249,
	"./WhatsApp Image 2022-02-09 at 3.08.10 PM (1).jpeg": 3898,
	"./WhatsApp Image 2022-02-09 at 3.08.10 PM.jpeg": 9729,
	"./WhatsApp Image 2022-02-09 at 3.08.11 PM (1).jpeg": 5496,
	"./WhatsApp Image 2022-02-09 at 3.08.11 PM.jpeg": 7856,
	"./WhatsApp Image 2022-02-09 at 3.08.12 PM.jpeg": 5253,
	"./WhatsApp Image 2022-02-09 at 3.26.49 PM.jpeg": 5444,
	"./WhatsApp Image 2022-02-09 at 3.26.51 PM.jpeg": 5620,
	"./WhatsApp Image 2022-02-10 at 1.09.44 PM (1).jpeg": 7629,
	"./WhatsApp Image 2022-02-10 at 1.09.44 PM.jpeg": 9907,
	"./WhatsApp Image 2022-02-10 at 1.09.45 PM.jpeg": 6759,
	"./WhatsApp Image 2022-02-10 at 1.09.47 PM (1).jpeg": 4634,
	"./WhatsApp Image 2022-02-10 at 1.09.47 PM (2).jpeg": 5417,
	"./WhatsApp Image 2022-02-10 at 1.09.47 PM.jpeg": 2020,
	"./WhatsApp Image 2022-02-10 at 1.10.00 PM.jpeg": 8975,
	"./WhatsApp Image 2022-02-10 at 1.10.04 PM.jpeg": 8450,
	"./WhatsApp Image 2022-02-10 at 1.10.07 PM.jpeg": 2497,
	"./WhatsApp Image 2022-02-10 at 1.33.31 PM.jpeg": 5641,
	"./WhatsApp Image 2022-02-10 at 1.34.30 PM.jpeg": 5286,
	"./WhatsApp Image 2022-02-10 at 1.36.03 PM.jpeg": 4158,
	"./WhatsApp Image 2022-02-10 at 1.36.57 PM.jpeg": 8660,
	"./WhatsApp Image 2022-02-10 at 1.37.47 PM.jpeg": 4857,
	"./WhatsApp Image 2022-02-10 at 1.39.19 PM.jpeg": 2299,
	"./WhatsApp Image 2022-05-23 at 2.40.08 PM (3) (1).jpeg": 5159,
	"./WhatsApp Image 2022-05-23 at 2.40.09 PM (8) (2).jpeg": 4884,
	"./WhatsApp Image 2022-05-23 at 2.40.10 PM (1) (1) (1).jpeg": 691,
	"./Yoga (2) (1) (1).JPG": 2211,
	"./Yoga (4) (1).JPG": 1428,
	"./amphi.jfif": 9331,
	"./art room.jfif": 5077,
	"./bb 2.jfif": 7388,
	"./dance.jfif": 9748,
	"./env.jfif": 4473,
	"./fire drill.jfif": 208,
	"./parent1.jpg": 7903,
	"./parent_engagement_2.jpg": 8114,
	"./photo.jpg": 8748,
	"./safe_campus.jpg": 5235,
	"./school pic.png": 3391,
	"./sport-14.jpg": 5058,
	"./sport-5.jpg": 3631,
	"./sports room.jpg": 759,
	"./sports.jpg": 4714,
	"./stem-2.jpeg": 7286,
	"./stem-3.3bd57bfbce0dd6a67b0f.jpeg": 492,
	"./stem-3.jpeg": 5840,
	"./swach.jfif": 1600
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5874;